const PriceSkeleton = () => {
  return (
    <div className="placeholder-glow">
      <span className="placeholder col-3"></span>
    </div>
  );
};

export default PriceSkeleton;